import React from 'react';
import { ArrowRight } from 'lucide-react';
import styles from './CTABand.module.css';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

export default function CTABand() {
  const ref = useScrollAnimation();

  const handleScroll = (href) => {
    const target = document.querySelector(href);
    if (target) window.scrollTo({ top: target.offsetTop - 80, behavior: 'smooth' });
  };

  return (
    <div className={styles.band}>
      <div className="container">
        <div className={`${styles.inner} fade-up`} ref={ref}>
          <div className={styles.glow} />
          <h2 className={styles.heading}>
            Ready to own Reddit
            <br />
            in your niche?
          </h2>
          <p className={styles.sub}>
            Start with any plan. Cancel anytime. Results from week one.
          </p>
          <div className={styles.buttons}>
            <button
              className="btn btn-primary btn-lg"
              onClick={() => handleScroll('#pricing')}
            >
              See plans & pricing <ArrowRight size={18} style={{ marginLeft: 4 }} />
            </button>
            <a
              href="mailto:hello@growthburrow.com"
              className="btn btn-outline btn-lg"
            >
              Talk to us first
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
